import React from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import { iWebFormField } from '../schema';
import { FormHelperText } from '@mui/material';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';

export interface WebformPhoneFieldProps extends PhoneInputProps {
	label?: string;
    fieldConfig : iWebFormField;
	idNamespace?: string;
	required?: boolean;
}

const WebformPhoneField: React.FC<WebformPhoneFieldProps> = ({
	label,
	idNamespace,
	inputProps,
    fieldConfig,
	...phoneInputProps
}) => {
    const { fieldPlaceholder, fieldDescription, fieldLabel, isMandatory,removeRequired, id} = fieldConfig;
    
    return (
	<div className="webform-phone-field">
		{fieldLabel && (
			// <label className="webform-phone-field__label">
			// 	{fieldLabel}
			// 	{isMandatory && <span aria-hidden="true"> *</span>}
			// </label>
            <CustomFormLabel
            labelName={fieldLabel}
            isMandotary={isMandatory}
            classNames='app-field-label'
        />
		)}
		<PhoneInput
			{...phoneInputProps}
			inputProps={{
				...inputProps,
                id: `${idNamespace ? idNamespace + '_' : ''}${id}`,
				'aria-label': (inputProps as React.InputHTMLAttributes<HTMLInputElement> | undefined)?.['aria-label'] || label,
                placeholder: fieldPlaceholder,
                name: `${idNamespace ? idNamespace + '_' : ''}${id}`,
                required: isMandatory && !removeRequired,
				// 'aria-invalid': error ? true : undefined,
			}}
            specialLabel={fieldLabel}
            autocompleteSearch={true} 
            enableSearch={true} 
            country={"gb"}  
            inputStyle={{ height: "52px", width: "100%" }}
		/>
		{(fieldDescription && fieldDescription.trim() !== "") && <FormHelperText className="helper-text-webform">{fieldDescription}</FormHelperText>}
	</div>
    );
};

WebformPhoneField.defaultProps = {
	country: 'us',
	enableSearch: true,
};

export default WebformPhoneField;
